import listmodule from './list.js';
import { MEDICINESCHEDULELIST_CLIENTID, MEDICINESCHEDULELIST_DATE } from '../actions/medicinescheduleactions';
import moment from 'moment';
const state = {
    ...listmodule.state,
    clientId: null,
    date: new Date()
};

const getters = {
    ...listmodule.getters,
    clientId: state => state.clientId,
    date: state => state.date,
};

const actions = {
    ...listmodule.actions,
    [MEDICINESCHEDULELIST_CLIENTID]: ({ commit }, clientId) => {
        
        commit(MEDICINESCHEDULELIST_CLIENTID, clientId);
    },
    [MEDICINESCHEDULELIST_DATE]: ({ commit }, date) => {

        commit(MEDICINESCHEDULELIST_DATE, date);
    },
};

const mutations = {
    ...listmodule.mutations,
    [MEDICINESCHEDULELIST_CLIENTID]: (state, clientId) => {
        state.clientId = clientId;
    },
    [MEDICINESCHEDULELIST_DATE]: (state, date) => {
        state.date = date;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};